export const LastUpdated = '19 Février 2026';
